import * as React from "react"

import LogoSvg from "@/images/tidb-icon.svg"

interface IProps {
  width?: number
  height?: number
}

const TiDBLogo: React.FC<IProps> = ({ width, height }) => {
  return <img src={LogoSvg} style={{ width, height }} alt={"TiDB Logo"} />
}

export default TiDBLogo
